<div
  stack-layout
  gap="md"
  elevation="raised"
  paddingVertical="md"
  paddingHorizontal="lg"
  borderRadius="xs"
  position="relative"
>
  <div row-layout justifyContent="space-between">
    <Text display="block" role="headline-small"> {{ headline() }} </Text>
    <ng-content select="header-content"></ng-content>
  </div>
  <ng-content></ng-content>

  <!-- Loading Overlay -->
  @if (loading()) {
    <div
      oui-center-layout
      position="absolute"
      [inset]="0"
      backgroundColor="scrim"
      [class]="loadingOverlayClass"
      zIndex="overlay"
    >
      <div
        oui-stack-layout
        alignItems="center"
        gap="sm"
        backgroundColor="scrim"
        padding="lg"
        borderRadius="lg"
      >
        <oui-text display="block">{{
          loadingMessage() || 'Loading...'
        }}</oui-text>
        <oui-progress-gauge
          [variant]="loadingError() ? 'warn' : 'success'"
          [percent]="loadingProgress() || 0"
        />
      </div>

      <!-- Loading Spinner -- TODO: Set up conditional loading spinner
      <div oui-box-layout [height]="40" [width]="40">
        <oui-icon name="spinner" color="primary" />
      </div> -->
    </div>
  }
</div>
